import { type FC } from "react";

import { formatNumberNoSuffix } from "../../../../lens-stats/formatters";
import { type RendererProps } from "../../../models/dimension-funnel";

import { LABEL_PADDING_LEFT, customLabel, xAxisPoints } from "./engagementFunnel.styles";

export const CustomLabel: FC<RendererProps> = ({ index, value }) => {
    if (typeof index !== "number") {
        throw new TypeError("Missing custom label index.");
    }
    return (
        <text
            x={(xAxisPoints[index] ?? 0) + LABEL_PADDING_LEFT}
            dy={32}
            y={0}
            textAnchor="start"
            className={customLabel}
        >
            {value ? formatNumberNoSuffix(value) : "-"}
        </text>
    );
};
